import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

// Public routes - no authentication required
export function PublicRoute({ element, allowIfLoggedIn = false }) {
  const { userId } = useContext(AuthContext);

  // If `allowIfLoggedIn` is true, don't redirect even if `userId` exists
  if (userId && !allowIfLoggedIn) {
    return <Navigate to="/" />;
  }

  return element;
}

// Basic user routes - authentication required, any subscription status
export function BasicUserRoute({ element }) {
  const { userId, isLoading } = useContext(AuthContext);
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>; // Or your loading spinner
  }

  if (!userId) {
    // Store the current path for redirect after login
    const redirectPath = location.pathname + location.search;
    console.log(`BasicUserRoute: Storing redirect path: ${redirectPath}`);
    localStorage.setItem("redirectAfterLogin", redirectPath);
    return <Navigate to="/login" replace />;
  }

  // User is authenticated and can access this route
  // Check if this matches the stored redirect path and clear it
  const storedRedirect = localStorage.getItem("redirectAfterLogin");
  if (
    storedRedirect &&
    location.pathname + location.search === storedRedirect
  ) {
    console.log(
      `BasicUserRoute: User reached intended destination, clearing redirect: ${storedRedirect}`
    );
    localStorage.removeItem("redirectAfterLogin");
  }

  return element;
}

// Premium user routes - authentication + active subscription required
export function PremiumUserRoute({ element }) {
  const { userId, isLoading, userType, subscriptionStatus } =
    useContext(AuthContext);
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>; // Or your loading spinner
  }

  if (!userId) {
    // Store the current path for redirect after login
    const redirectPath = location.pathname + location.search;
    localStorage.setItem("redirectAfterLogin", redirectPath);
    return <Navigate to="/login" replace />;
  }

  // Check if user has active subscription
  if (userType !== "premium" || subscriptionStatus !== "active") {
    return <Navigate to="/" replace />;
  }

  // User is authenticated and has premium access
  // Check if this matches the stored redirect path and clear it
  const storedRedirect = localStorage.getItem("redirectAfterLogin");
  if (
    storedRedirect &&
    location.pathname + location.search === storedRedirect
  ) {
    console.log(
      `PremiumUserRoute: User reached intended destination, clearing redirect: ${storedRedirect}`
    );
    localStorage.removeItem("redirectAfterLogin");
  }

  return element;
}

// Backward compatibility - keep existing ProtectedRoute
export function ProtectedRoute({ element }) {
  return <BasicUserRoute element={element} />;
}

// Backward compatibility - keep existing PaidPremiumRoute
export function PaidPremiumRoute({ element }) {
  return <PremiumUserRoute element={element} />;
}
